import { Component, OnInit  } from '@angular/core';
import { UtilidadesService } from '../../@core/utils/utilidades.service';
import { PeticionesHttpBackEndService } from '../../@core/mock/peticiones-http-backend.service';
import { Router, ActivatedRoute } from '@angular/router';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NbTrigger } from '@nebular/theme';
export interface Etiqueta {
  id:any;
  name: string;
}
@Component({
  selector: 'ngx-pestania-social',
  templateUrl: './pestania-social.component.html',
  styleUrls: ['./pestania-social.component.scss'],
  providers: [UtilidadesService,PeticionesHttpBackEndService]
})

export class PestaniaSocialComponent implements OnInit {


  parametrosUrl: any;
  Token: any;
  usuario:any;
  etiqueta: Etiqueta[];
  selectable: boolean;
  removable: boolean;
  longitudEtiquetas: number;
  avisoEtiquetaMax: boolean;
  etiquetaValid: String;
  addOnBlur: boolean;
  RedesSociales: Array<any>;
  openModal: any;
  DatosUsuario: any;
  LogoRed:any;
  SelectRedSocial: Number;
  RedesSocialesDelete: Array<any>;
  imagen:any;
  datosSocial:any;
  cita:any;
  biografia:any;
  lopdCheck:any;
  tiposEtiquetas:any;
  imagenUser:any;
  resultado:any;
  imagenRuta:any;
  position: String;
  etiquetaSeleccionadaInfo:any;
  etiquetaSeleccionadaInfoFiltrado:any;
  buscarEtiqueta:any;
  tipoEtiquetaSeleccionada:any;
  nombreAsuntos:any;
  descripcionBaja:any;
  nombreAyuda:any;
  descripcionAyuda:any;
  buscarEtiquetaProvincias:any;
  provinciasActivadas:any;
  desactivarProvincias:any;
  desactivarPaises:any;


  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  readonly separatorKeysCodes2: number[] = [ENTER, COMMA];
  constructor(private _route: ActivatedRoute, private utilidades: UtilidadesService, public _http: PeticionesHttpBackEndService,private router:Router,private modalService: NgbModal){
    _route.queryParams.subscribe(params => {
      this.parametrosUrl = params || null;
    });
    this.Token = JSON.parse(localStorage.getItem('auth_app_token'));
    this.etiqueta = [];
    this.RedesSociales = [];
    this.selectable = true;
    this.removable = true;
    this.longitudEtiquetas = 0;
    this.avisoEtiquetaMax = false;
    this.etiquetaValid = "";
    this.addOnBlur = true;
    this.DatosUsuario = {Entidad:{},FormasPago:{}}
    this.SelectRedSocial= 0;
    this.RedesSocialesDelete = [];
    this.position = "right";
    this.tipoEtiquetaSeleccionada = 0;
    this.nombreAsuntos = "";
    this.descripcionBaja = "";
    this.nombreAyuda = "";
    this.descripcionAyuda = "";
    this.buscarEtiquetaProvincias = "";
    this.provinciasActivadas = false;
    this.desactivarProvincias = false;
    this.desactivarPaises = false;


  }
  open(content) {
    this.descripcionBaja = "";
    this.openModal = this.modalService.open(content);
  }
  cargaInicial(){
    this._http.getOneReg("v1/getInfoSocial",this.usuario.Entidad._entidad_id+"/"+this.usuario.Entidad._entidad_id).subscribe(
      result => {
        this.datosSocial = result;
        this.cita = this.datosSocial.ExtesionSocial._cita;
        this.biografia = this.datosSocial.ExtesionSocial._biografia;
        this.lopdCheck = this.datosSocial.ExtesionSocial._lopd;
        if(this.lopdCheck == null){
          this.lopdCheck = false;
        }
        this.imagenUser = this.datosSocial.ExtesionSocial._imagen_u_r_l;
        this.tiposEtiquetas = this.datosSocial.TipoEtiquetas;
        let etiquetasUser = this.datosSocial.EtiquetasUser;
        let etiquetasDefinidas = this.datosSocial.EtiquetasDefinidas;
        if(this.tiposEtiquetas != null && this.tiposEtiquetas.length > 0){
          if(etiquetasUser  != null && etiquetasUser.length > 0){
            etiquetasUser.forEach(etiquetasUser => {
              this.tiposEtiquetas.forEach(tipoEtiqueta => {
                if(tipoEtiqueta.texto == null){
                  tipoEtiqueta.texto =[];
                }
                if(tipoEtiqueta._tipo_etiqueta_id == etiquetasUser.TipoEtiquetaId){
                  if(etiquetasUser.TipoEtiquetaId == 4){
                  }
                  if (etiquetasUser.Texto != null) {
                    
                    let et = etiquetasUser.Texto.split(";");
                    et.forEach(x => {
                      if (x.trim() !== "") {
                        let id = etiquetasUser.TipoEtiquetaId == 4 ? etiquetasUser : etiquetasDefinidas.find( t => this.filtrar_acentos(t.Texto) === this.filtrar_acentos(x.trim()));
                        tipoEtiqueta.texto.push({ name: x.trim(),id: id !== undefined   ? id.EtiquetaId : 0});//&& id.TipoEtiquetaId !==4
                      }
                    });
                  }
                }
              });
            });
          }else{
            this.tiposEtiquetas.forEach(tipoEtiqueta => {
              if(tipoEtiqueta.texto == null){
                tipoEtiqueta.texto =[];
              }
            });
          }
          etiquetasDefinidas.forEach(etiquetasDefinidas => {
            this.tiposEtiquetas.forEach(tipoEtiqueta => {
              if(tipoEtiqueta.textoDefinido == null){
                tipoEtiqueta.textoDefinido = [];
              }
              if(tipoEtiqueta.textoDefinidoProvincias == null){
                tipoEtiqueta.textoDefinidoProvincias = [];
              }
              if(tipoEtiqueta._tipo_etiqueta_id == etiquetasDefinidas.TipoEtiquetaId){
                if(tipoEtiqueta._tipo_etiqueta_id == 1){
                  if(etiquetasDefinidas.Pertenece !== null && etiquetasDefinidas.Pertenece !== undefined){
                    tipoEtiqueta.textoDefinidoProvincias.push({name:etiquetasDefinidas.Texto,id:etiquetasDefinidas.EtiquetaId,Pertenece:etiquetasDefinidas.Pertenece !== null ? etiquetasDefinidas.Pertenece : null}); 
                  }else{
                    tipoEtiqueta.textoDefinido.push({name:etiquetasDefinidas.Texto,id:etiquetasDefinidas.EtiquetaId,Pertenece:etiquetasDefinidas.Pertenece !== null ? etiquetasDefinidas.Pertenece : null}); 
                  }
                }else{
                  tipoEtiqueta.textoDefinido.push({name:etiquetasDefinidas.Texto,id:etiquetasDefinidas.EtiquetaId,Pertenece:etiquetasDefinidas.Pertenece !== null ? etiquetasDefinidas.Pertenece : null});
                }
              }
            });
          });
        }
      });
  }
  ngOnInit() {

    this._http.getUsuario().subscribe(
      result => {
        this.usuario = result;
        this.cargaInicial();
        this._http.getOneReg("v1/admin/entidad",this.usuario.Entidad._entidad_id).subscribe(
          result => {
            this.DatosUsuario = result;
            this.RedesSociales = this.DatosUsuario.RedesSocialesSocial;
            for (var i=0; i < this.RedesSociales.length;i++){
              this.RedesSociales[i].identificador = Math.floor((Math.random() * 1000000000000) + 1);
            }
          });
      }
    );

  }
  public cambioValorArrayRedesSociales(event){
    for(var i=0;i<this.RedesSociales.length;i++){
      if (this.RedesSociales[i].identificador == event.identificador){
        if (event.inputType == "text"){
          switch(event.key){
            case "_url": this.RedesSociales[i]._url = event.value;break;
            case "_comentario": this.RedesSociales[i]._comentario = event.value;break;
          }
        }
      }
    } 
  }
   /**
   * Eliminar etiqueta
   * @param etiqueta 
   */
  remove(etiqueta: Etiqueta,listEtiquetas): void {

    let index = listEtiquetas.indexOf(etiqueta);
    this.tiposEtiquetas.forEach(element => {
      if(element._tipo_etiqueta_id == 1){
        element.textoDefinido.forEach(valor => {
          if(listEtiquetas.length > 0 && valor.id == listEtiquetas[index].id){
              listEtiquetas.splice(0, listEtiquetas.length);
              if(this.etiquetaSeleccionadaInfo !== undefined && this.etiquetaSeleccionadaInfo.texto.length > 0){
                this.etiquetaSeleccionadaInfo.texto.splice(0, listEtiquetas.length);
              }
              this.longitudEtiquetas -= etiqueta.name.length;
              if (this.longitudEtiquetas <= 500) {
                this.avisoEtiquetaMax = false;
                this.etiquetaValid = this.avisoEtiquetaMax ? "border-dangerC" : "";
              }
              index = 0;
          }
          
        });
      }
    });
    if(this.etiquetaSeleccionadaInfo !== undefined){
      this.etiquetaSeleccionadaInfo.textoDefinido.forEach(valor2 => {
        if(listEtiquetas.length > 0 && listEtiquetas[index].id == valor2.id){
          this.provinciasActivadas = false;
        }
      });
      this.etiquetaSeleccionadaInfo.textoDefinidoProvincias.forEach(valor2 => {
        if(listEtiquetas.length > 0 && listEtiquetas[index].id == valor2.id){
          this.provinciasActivadas = true;
        }
      });
    }
    
    if (index >= 0) {
      listEtiquetas.splice(index, 1);
      if(this.etiquetaSeleccionadaInfo !== undefined && this.etiquetaSeleccionadaInfo.texto.length > 0){
        this.etiquetaSeleccionadaInfo.texto.splice(index, 1);
            }
      this.longitudEtiquetas -= etiqueta.name.length;
      if (this.longitudEtiquetas <= 500) {
        this.avisoEtiquetaMax = false;
        this.etiquetaValid = this.avisoEtiquetaMax ? "border-dangerC" : "";
      }
    }
    this.comprobarEtiquetas();
  }
  selectRedSocial(event){
    this.LogoRed =  this.DatosUsuario.ListRedesSocialesSocial[event.target.value]._logo;
    this.SelectRedSocial = this.DatosUsuario.ListRedesSocialesSocial[event.target.value]._red_social_id;
  }
    /**
   * Añadir etiqueta
   * @param event 
   */
  add(event: MatChipInputEvent,etq): void {
    let etiqueta = etq.texto;
    let textoDefinido = etq.textoDefinido;
    let tipoEtiquetaId = etq._tipo_etiqueta_id;
    const input = event.input;
    const value = event.value;
    // Add our fruit
    if ((value || '').trim()) {
      if(tipoEtiquetaId !== 4){
        const resultado = textoDefinido.find( t => this.filtrar_acentos(t.name) === this.filtrar_acentos(value));
        if(resultado == undefined){
          this.utilidades.notificationWarning("Aviso","No se encuentra entre las etiquetas permitidas","top-left");
        }else{
          etiqueta.push({ name: resultado.name.trim(),id:resultado.id });
          this.longitudEtiquetas += value.length;
          if (this.longitudEtiquetas >= 500) {
            this.avisoEtiquetaMax = true;
            this.etiquetaValid = this.avisoEtiquetaMax ? "border-dangerC" : "";
          }
        }
      }else{
        etiqueta.push({ name: value.trim(),id: 0});
        this.longitudEtiquetas += value.length;
        if (this.longitudEtiquetas >= 500) {
          this.avisoEtiquetaMax = true;
          this.etiquetaValid = this.avisoEtiquetaMax ? "border-dangerC" : "";
        }
      }
 
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  public submitAddRedSocial(){
    if (this.SelectRedSocial == 0){
      this.utilidades.notificationWarning("Aviso","Tienes que seleccionar una red social para poder añadirla","top-left");
    }else{
      this.RedesSociales.push({"identificador":Math.floor((Math.random() * 1000000000000) + 1),"_comentario":"","_red_social_id":this.SelectRedSocial,"_red_social_entidad_id":"","_entidad_id":"","_url":"","_logo":this.LogoRed});
    }  
    this.SelectRedSocial = 0;
    this.openModal.close();
  }

  public deleteRedSocialSocio(event){
    if (window.confirm('¿Seguro que quieres eliminar esta red social?')) {
      for(var i=0;i<this.RedesSociales.length;i++){
        if (this.RedesSociales[i].identificador == event.identificador){
          this.RedesSocialesDelete.push(this.RedesSociales[i]);
          this.RedesSociales.splice(i, 1 );
        }  
      } 
    }
  }
  selectedFile:File;
  handleFileInput(event){
    this.selectedFile = event.target.files[0];
    var file:File = event.target.files[0];
    var myReader:FileReader = new FileReader();

    myReader.onloadend = (e) => {
      this.imagenUser = myReader.result;
    }
    myReader.readAsDataURL(file);
 
    }
    save(){
      if((this.cita !== null  && this.cita !== undefined && this.cita.length > 0) && (this.biografia !== null  && this.biografia !== undefined && this.biografia.length > 0)){
        this.imagenRuta = null;
        if(this.selectedFile !== null && this.selectedFile !== undefined){
          const formData = new FormData();
          formData.append('file', this.selectedFile);
          this._http.uploadImgPerfil(formData,this.usuario.Entidad._entidad_id)
              .subscribe(res => {
                this.resultado = res;
                if (this.resultado.Code == 200){
                  this.imagenRuta = this.resultado.rutaImagen;
                }else{
                  this.utilidades.notificationWarning("Aviso",this.resultado.Mensaje,"top-left");
                }
                this._http.insertaObjecto("v1/updatePestaniaSocial",{Data: {"entidadId":this.usuario.Entidad._entidad_id,"cita":this.cita,"biografia":this.biografia,
                "etiquetas":this.tiposEtiquetas,"redesSociales":this.RedesSociales,"redesSocialesDelete":this.RedesSocialesDelete,"imagen":this.imagenRuta,"lopd":this.lopdCheck}}).subscribe(
                  result => {
                    let resultado :any = result;
                    if(!this.lopdCheck){
                      this.utilidades.notificationWarning("Aviso","Si no acepta los terminos no podra ver los muros","top-left");
                    }
                    if(resultado.Code == 200){
                      this.cargaInicial();
                      this.utilidades.notificationSuccess("Aviso",resultado.Mensaje,"top-left");
                    }
                  },
                  error => {
                  }
                );
              })
        }else{
          this._http.insertaObjecto("v1/updatePestaniaSocial",{Data: {"entidadId":this.usuario.Entidad._entidad_id,"cita":this.cita,"biografia":this.biografia,
          "etiquetas":this.tiposEtiquetas,"redesSociales":this.RedesSociales,"redesSocialesDelete":this.RedesSocialesDelete,"imagen":this.imagenRuta,"lopd":this.lopdCheck}}).subscribe(
            result => {
              let resultado :any = result;
              if(!this.lopdCheck){
                this.utilidades.notificationWarning("Aviso","Si no acepta los terminos no podra ver los muros","top-left");
              }
              if(resultado.Code == 200){
                this.cargaInicial(); 
                this.utilidades.notificationSuccess("Aviso",resultado.Mensaje,"top-left");
              }
            },
            error => {
            }
          );
        }
       
      }else{
        this.utilidades.notificationWarning("Aviso","Debe rellenar los campos \"Cita, frase o reflexión\" y \"Mi bio\"","top-left");
      }
      
    }

    filtrar_acentos(input){

      var acentos = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç";
      var original = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc";
      for (var i = 0; i < acentos.length; i++) {
          input = input.replace(acentos.charAt(i), original.charAt(i)).toLowerCase();
      };
      return input;
 }
 infoPulsada(evento){
   this.etiquetaSeleccionadaInfo = JSON.parse(JSON.stringify(evento));
   this.etiquetaSeleccionadaInfoFiltrado = JSON.parse(JSON.stringify(evento));
   this.buscarEtiqueta = "";
   this.buscarEtiquetaProvincias = "";
   this.tipoEtiquetaSeleccionada = evento._tipo_etiqueta_id;
   if(this.tipoEtiquetaSeleccionada == 1 || this.tipoEtiquetaSeleccionada == 2){
     this.nombreAsuntos = "Filtrar";
   }else{
     this.nombreAsuntos = "Nueva etiqueta";
   }
   this.comprobarEtiquetas();
 }

 ayudaPulsada(evento){
   this.nombreAyuda = evento._nombre
   switch (evento._tipo_etiqueta_id) {
    case 1:
        this.descripcionAyuda = "Haga click en <i class='fas fa-plus-square'></i> y seleccione la etiqueta que desee a partir del botón <i class='fas fa-plus color'></i>";
        break;
    case 2:
      this.descripcionAyuda = "Haga click en <i class='fas fa-plus-square'></i> y seleccione la etiqueta que desee a partir del botón <i class='fas fa-plus color'></i>";
        break;
    case 3:
      this.descripcionAyuda = "Haga click en <i class='fas fa-plus-square'></i> y seleccione la etiqueta que desee a partir del botón <i class='fas fa-plus color'></i> o cree su propia etiqueta escribiéndola en el campo de texto y posteriormente haciendo click en el botón <i class='fas fa-plus color'></i> situado a su derecha";
        break;
    case 4:
      this.descripcionAyuda = "Escriba su etiqueta y cuando la tenga lista pulse 'Intro'";
        break;
}
 }
 comprobarEtiquetas(){
  this.desactivarPaises = false;
  this.desactivarProvincias = false;
  this.provinciasActivadas = false;
  if(this.etiquetaSeleccionadaInfo !== undefined){
  this.tiposEtiquetas.forEach(element => {
    if(element._tipo_etiqueta_id == 1){
      element.texto.forEach(valor => {
        this.etiquetaSeleccionadaInfo.textoDefinido.forEach(valor2 => {
          if(valor.id == valor2.id){
            this.desactivarPaises = true;
            if(valor.name.toLowerCase() == "españa"){
              this.provinciasActivadas = true;
            }else{
              this.provinciasActivadas = false;
            }
          }
        });
        this.etiquetaSeleccionadaInfo.textoDefinidoProvincias.forEach(valor2 => {
          if(valor.id == valor2.id){
            this.desactivarProvincias = true;
            this.provinciasActivadas = true;
          }
        });
        
      });
    }
  });
}
}
 addEtiquetaProvincias(etiqueta: Etiqueta){
  if(!this.desactivarProvincias){
    this.addEtiquetaDefinida(etiqueta.name,this.etiquetaSeleccionadaInfo,true);
  }
  this.comprobarEtiquetas();
 
}

addEtiquetaPaises(etiqueta: Etiqueta){
  if(etiqueta.name.toLowerCase() == "españa"){
    this.provinciasActivadas = true;
  }else{
    this.provinciasActivadas = false;
  }
  if(!this.desactivarPaises){
    this.addEtiquetaDefinida(etiqueta.name,this.etiquetaSeleccionadaInfo,false);
  }
  this.comprobarEtiquetas();
 
}
 addEtiqueta(etiqueta: Etiqueta){
    this.addEtiquetaDefinida(etiqueta.name,this.etiquetaSeleccionadaInfo,false);
 }

    /**
   * Añadir etiqueta
   * @param event 
   */
  addEtiquetaDefinida(values,etq,esProvincias): void {
    let etiqueta = etq.texto;
    let textoDefinido = esProvincias ? etq.textoDefinidoProvincias : etq.textoDefinido;
    let tipoEtiquetaId = etq._tipo_etiqueta_id;
    const value = values;
    // Add our fruit
    if ((value || '').trim()) {
      if(tipoEtiquetaId !== 4){
        const resultado = textoDefinido.find( t => this.filtrar_acentos(t.name) === this.filtrar_acentos(value));
        if(resultado == undefined){
          this.utilidades.notificationWarning("Aviso","No se encuentra entre las etiquetas permitidas","top-left");
        }else{
          etiqueta.push({ name: resultado.name.trim(),id:resultado.id });
          this.longitudEtiquetas += value.length;
          if (this.longitudEtiquetas >= 500) {
            this.avisoEtiquetaMax = true;
            this.etiquetaValid = this.avisoEtiquetaMax ? "border-dangerC" : "";
          }
        }
      }else{
        etiqueta.push({ name: value.trim(),id:0 });
        this.longitudEtiquetas += value.length;
        if (this.longitudEtiquetas >= 500) {
          this.avisoEtiquetaMax = true;
          this.etiquetaValid = this.avisoEtiquetaMax ? "border-dangerC" : "";
        }
      }
 
    }
    this.tiposEtiquetas.forEach(element => {
      if(tipoEtiquetaId == element._tipo_etiqueta_id){
        element.texto = JSON.parse(JSON.stringify(etiqueta));
      }
    });
  }

  buscar(){
    this.etiquetaSeleccionadaInfoFiltrado = JSON.parse(JSON.stringify(this.etiquetaSeleccionadaInfo))
    if(this.buscarEtiqueta !== ""){
      this.etiquetaSeleccionadaInfoFiltrado.textoDefinido = [];
      this.etiquetaSeleccionadaInfo.textoDefinido.forEach(element => {
        if(this.filtrar_acentos(element.name).indexOf(this.filtrar_acentos(this.buscarEtiqueta)) !== -1){
          this.etiquetaSeleccionadaInfoFiltrado.textoDefinido.push(element);
        }
      });
    }
  }

  buscarProvincias(){
    this.etiquetaSeleccionadaInfoFiltrado = JSON.parse(JSON.stringify(this.etiquetaSeleccionadaInfo))
    if(this.buscarEtiquetaProvincias !== ""){
      this.etiquetaSeleccionadaInfoFiltrado.textoDefinidoProvincias = [];
      this.etiquetaSeleccionadaInfo.textoDefinidoProvincias.forEach(element => {
        if(this.filtrar_acentos(element.name).indexOf(this.filtrar_acentos(this.buscarEtiquetaProvincias)) !== -1){
          this.etiquetaSeleccionadaInfoFiltrado.textoDefinidoProvincias.push(element);
        }
      });
    }
  }

  anadirNuevaEtiqueta(){
    let p = 0;
    let array = {
      "name": this.buscarEtiqueta,
      "id":0
    }
    setTimeout(() => {
      this.tiposEtiquetas.forEach(element => {
        if(element._tipo_etiqueta_id == this.tipoEtiquetaSeleccionada){
          let textoEncontrado = element.textoDefinido.filter(e => e.name.toLowerCase() == this.buscarEtiqueta.toLowerCase());
          if(textoEncontrado.length == 0){
            element.textoDefinido.push(array);
            p = element;
          }else{
            this.utilidades.notificationWarning("Aviso","La etiqueta "+this.buscarEtiqueta+" ya existe","top-left");
          }
        }
      });
      if(p !== 0){
        this.etiquetaSeleccionadaInfo = JSON.parse(JSON.stringify(p));
        this.etiquetaSeleccionadaInfoFiltrado = JSON.parse(JSON.stringify(p));
        this.buscarEtiqueta = "";
      }
    
    }, 0);
  }

  infoAceptacion(content){
    this.openModal = this.modalService.open(content,{size: 'lg'});
  }

  aceptarBaja(){
    this._http.insertaObjecto("v1/bajaExtesionSocial",{Data: {"entidadId":this.usuario.Entidad._entidad_id,"descripcionBaja":this.descripcionBaja}}).subscribe(
            result => {
              let resultado:any = result;
              if(resultado.Code == 200){
                this.utilidades.notificationSuccess("Aviso",resultado.Mensaje,"top-left");
                this.openModal.close();
              }else{
                this.utilidades.notificationWarning("Aviso",resultado.Mensaje,"top-left");
              }
            },
            error => {
            }
          );
  }

  eliminarEtiqueta(evento){
    if(evento.id !== 0){
        this._http.insertaObjecto("v1/deleteEtiquetaSocial",{Data: {"entidadId":this.usuario.Entidad._entidad_id,"etiquetaId":evento.id}}).subscribe(
          result => {
            let resultado:any = result;
            if(resultado.Code == 200){
              this.utilidades.notificationSuccess("Aviso",resultado.Mensaje,"top-left");
              this.borrarEt(evento);
            }else{
              this.utilidades.notificationWarning("Aviso",resultado.Mensaje,"top-left");
            }
          },
          error => {
          }
        );
    
      }
      if(evento.id == 0){
       this.borrarEt(evento);
      }
 
  }

  borrarEt(evento){
    setTimeout(()=>{
      let textoEncontrado = this.tiposEtiquetas[2].textoDefinido.filter(e => e.name.toLowerCase() == evento.name.toLowerCase());
      if(textoEncontrado !== null){
        let index = this.tiposEtiquetas[2].textoDefinido.indexOf(textoEncontrado[0]);
        if(index !== -1){
          this.tiposEtiquetas[2].textoDefinido.splice(index,1);
          this.etiquetaSeleccionadaInfoFiltrado.textoDefinido.splice(index,1);
          this.etiquetaSeleccionadaInfo.textoDefinido.splice(index,1);
          if(this.etiquetaSeleccionadaInfo !== undefined && this.etiquetaSeleccionadaInfo.texto !== undefined){
            let i = -1;
            this.etiquetaSeleccionadaInfo.texto.forEach((element,id) => {
              if(element.name.toLowerCase() == evento.name.toLowerCase() && element.id == evento.id){
                i = id;
              }
            });
            if(i !== -1){
              this.etiquetaSeleccionadaInfo.texto.splice(i,1);
            }
          }
            if(this.tiposEtiquetas[2] !== undefined && this.tiposEtiquetas[2].texto !== undefined){
              let i = -1;
              this.tiposEtiquetas[2].texto.forEach((element,id) => {
                if(element.name.toLowerCase() == evento.name.toLowerCase() && element.id == evento.id){
                  i = id;
                }
              });
              if(i !== -1){
                this.tiposEtiquetas[2].texto.splice(i,1);
              }
            }
        }
      }       
    },0);
  }
  
 
}